import { render, staticRenderFns } from "./AdvertisingMeasuresCustomersList.vue?vue&type=template&id=5112d0fa&scoped=true&"
import script from "./AdvertisingMeasuresCustomersList.vue?vue&type=script&lang=js&"
export * from "./AdvertisingMeasuresCustomersList.vue?vue&type=script&lang=js&"
import style0 from "./AdvertisingMeasuresCustomersList.vue?vue&type=style&index=0&id=5112d0fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5112d0fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VDatePicker,VIcon,VMenu,VSelect,VSimpleCheckbox,VTextField})
